import { HasTenantResource, NestUpdateTrackingResource, ResourceConfig } from '@hidat/huijs-resource';
import { AnyHash, FieldConfig, FieldDataTypes, ModelInterface, uNumber, uString, Uuid } from '@hidat/huijs-common';
import { splixerFieldConfigs, splixerSystemFields } from './splixer-fields.const';

export const ScheduleQueueConfig: ResourceConfig = new ResourceConfig(
  'ScheduleQueue',
  'schedule_queues',
  true,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    splixerFieldConfigs.instanceId,
    new FieldConfig('listenerId', FieldDataTypes.UID),
    new FieldConfig('sourceType'),
    new FieldConfig('sourceId', FieldDataTypes.INTEGER),
    new FieldConfig('playbackConstraints', FieldDataTypes.HASH),
    new FieldConfig('seqNum', FieldDataTypes.INTEGER),
    new FieldConfig('playStatus', FieldDataTypes.INTEGER),
    new FieldConfig('playedAt', FieldDataTypes.DATETIME),
  ]);

/**
 * Schedule Queue
 * Holds the next items queued up for a listener/instance, pending being turned into a ScheduleLog entry.
 */
export interface ScheduleQueueInterface
  extends ModelInterface, NestUpdateTrackingResource, HasTenantResource {
  instanceId: number | undefined;
  listenerId: Uuid | undefined;
  sourceType: uString; // MediaItem, Segment, Show, Mix
  sourceId: uNumber;
  playbackConstraints: AnyHash | undefined;
  seqNum: uNumber;
  playStatus: number;
  playedAt: unknown;
}
